<template>
  <v-tooltip content-class="borderDark elevation-2" top max-width="300">
    <template v-slot:activator="{ on, attrs }">
      <span class="backgroundWhite titleLight--text" v-if="type == 'text'" v-bind="attrs" v-on="on">{{ title }} </span>
      <v-btn
        v-else-if="type == 'btn'"
        v-bind="attrs"
        v-on="on"
        class="py-7 opaque"
        :color="`${color} lighten-4`"
        dark
        depressed
      >
        <v-icon :color="`${color}`">{{ icon }}</v-icon>
      </v-btn>
      <v-icon v-else :size="size" :color="getColor(color)" dark v-bind="attrs" v-on="on">
        {{ icon ? icon : "mdi-help-circle-outline" }}
      </v-icon>
    </template>
    <span>{{ formattedText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "TooltipVT",
  props: {
    text: [String, Array],
    type: String,
    title: String,
    color: String,
    icon: String,
    size: {
      type: String,
      default: "small",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    formattedText() {
      if (this.text == null) return "No Issues";
      if (typeof this.text === "string") return this.text;
      let txt = "";
      this.text.map((item) => {
        txt += item + "\n";
      });
      return txt;
    },
  },
  methods: {
    getColor(color) {
      return color ? color : "primary";
    },
  },
};
</script>

<style scoped>
.transparent-span {
  background-color: transparent;
}
</style>
